module.exports = __webpack_public_path__ + "static/media/percent.f99f789d.svg";